// Add bunch of 4 levels ( create, read, update, delete ) for each permission
const clientPermissions = {
    profile_mnj_create: false,
    profile_mnj_read: false,
    profile_mnj_update: false,
    profile_mnj_delete: false,
    profile_mnj_display: false,
    employee_mnj_create: false,
    employee_mnj_read: false,
    employee_mnj_update: false,
    employee_mnj_delete: false,
    employee_mnj_display: false,
    designation_mnj_create: false,
    designation_mnj_read: false,
    designation_mnj_update: false,
    designation_mnj_delete: false,
    designation_mnj_display: false,
    team_mnj_create: false,
    team_mnj_read: false,
    team_mnj_update: false,
    team_mnj_delete: false,
    team_mnj_display: false,
    shift_mnj_create: false,
    shift_mnj_read: false,
    shift_mnj_update: false,
    shift_mnj_delete: false,
    shift_mnj_display: false,
    role_mnj_create: false,
    role_mnj_read: false,
    role_mnj_update: false,
    role_mnj_delete: false,
    role_mnj_display: false,
    wfh_mnj_create: false,
    wfh_mnj_read: false,
    wfh_mnj_update: false,
    wfh_mnj_delete: false,
    wfh_mnj_display: true,
    holiday_mnj_create: false,
    holiday_mnj_read: false,
    holiday_mnj_update: false,
    holiday_mnj_delete: false,
    holiday_mnj_display: false,
    attendance_mnj_create: false,
    attendance_mnj_read: false,
    attendance_mnj_update: false,
    attendance_mnj_delete: false,
    attendance_mnj_display: false,
    analytics_mnj_create: false,
    analytics_mnj_read: false,
    analytics_mnj_update: false,
    analytics_mnj_delete: false,
    analytics_mnj_display: false,
    setting_mnj_create: false,
    setting_mnj_read: false,
    setting_mnj_update: false,
    setting_mnj_delete: false,
    setting_mnj_display: false,
    search_mnj_create: false,
    search_mnj_read: false,
    search_mnj_update: false,
    search_mnj_delete: false,
    search_mnj_display: true,
    payrollnote_mnj_create: false,
    payrollnote_mnj_read: false,
    payrollnote_mnj_update: false,
    payrollnote_mnj_delete: false,
    payrollnote_mnj_display: false,
    mail_mnj_create: false,
    mail_mnj_read: false,
    mail_mnj_update: false,
    mail_mnj_delete: false,
    mail_mnj_display: false,
    rleave_mnj_create: false,
    rleave_mnj_read: false,
    rleave_mnj_update: false,
    rleave_mnj_delete: false,
    rleave_mnj_display: false,
};

const convertServerRoleToClient = (data) => {

    let permissionsObject = { ...clientPermissions };

    const { permissions: routePermissionsObject, ...restData } = data;

    Object.entries(routePermissionsObject).forEach(permission => {

        const [label, permissionObject] = permission;
        const routePermissions = permissionObject?.routes;
        const isComponent = permissionObject?.isComponent;
        const permissionLabel = label.replace('management', 'mnj');

        routePermissions.forEach(level => {
            permissionsObject[permissionLabel + '_' + level] = true;
        });

        permissionsObject[permissionLabel + '_display'] = isComponent;
    });

    return {
        ...restData,
        ...permissionsObject,
    };

};

const convertClientPermissionsToServer = (permissions) => {
    const includedAllowedRoutes = [];

    Object.entries(permissions).forEach(([permission, allowed]) => {
        const displayPermission = permission.includes('display');
        const [label, mnj, level] = permission.split('_');
        const routeLabel = `${label} Management`;

        if (!displayPermission && allowed) {
            const existedRouteIndex = includedAllowedRoutes.findIndex(
                (allowedRoute) => allowedRoute.label === routeLabel
            );

            if (existedRouteIndex !== -1) {
                includedAllowedRoutes[existedRouteIndex].permissions.push(level);
            } else {
                includedAllowedRoutes.push({
                    label: routeLabel,
                    permissions: [level],
                });
            }
        }

        if (displayPermission) {
            const isComponent = allowed;
            const existedRouteIndex = includedAllowedRoutes.findIndex(
                (allowedRoute) => allowedRoute.label === routeLabel
            );

            if (existedRouteIndex !== -1) {
                includedAllowedRoutes[existedRouteIndex].isComponent = isComponent;
            }
        }
    });

    return includedAllowedRoutes;
};

export {
    clientPermissions,
    convertServerRoleToClient,
    convertClientPermissionsToServer,
}